export default defineAppConfig({
  contentfulLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    contentfulLayer?: {};
  }
}
